import { StateCreator } from "zustand";
import { AgentDetailSaveScope, IAgentDetails } from "../../agentDetail.model";
import { AgentsStore } from "../agentsTypes";
import { EMPTY_RESTRICTED_FIELDS, initialAgentDetailState } from "./agentDetailState";
import {
    applyResetScopeToDraft,
    cloneAgentDetails,
    isFieldEditable,
    normalizeDraftFieldValue,
} from "./agentDetail.utils";
import { AgentDetailActions } from "./agentDetailTypes";

export const createAgentDetailActions: StateCreator<AgentsStore, [], [], AgentDetailActions> = (set, get) => ({
    resetAgentDetail: () => set({ detail: initialAgentDetailState }),

    setAgentDetailData: (data: IAgentDetails, userId: number) =>
        set({
            detail: {
                ...get().detail,
                activeUserId: userId,
                data,
                draft: cloneAgentDetails(data),
                status: "success",
                error: null,
                isEditMode: true,
            },
        }),

    enterEditMode: () => {
        const { detail } = get();
        if (!detail.data) return;

        set({
            detail: {
                ...detail,
                isEditMode: true,
                draft: detail.draft ?? cloneAgentDetails(detail.data),
            },
        });
    },

    exitEditMode: () => {
        const { detail } = get();
        if (!detail.data) return;

        set({
            detail: {
                ...detail,
                isEditMode: false,
                draft: cloneAgentDetails(detail.data),
            },
        });
    },

    resetDraftScope: (scope: AgentDetailSaveScope = "all") => {
        const { detail } = get();
        if (!detail.data || !detail.draft) return;

        set({
            detail: {
                ...detail,
                draft: applyResetScopeToDraft(detail.draft, detail.data, scope),
            },
        });
    },

    updateDraftField: (section, field, value) => {
        const { detail } = get();
        if (!detail.draft || !detail.data) return;

        const restricted = detail.data.restrictedFields ?? EMPTY_RESTRICTED_FIELDS;
        if (!isFieldEditable(restricted, section, field)) return;

        const normalizedValue = normalizeDraftFieldValue(value);
        set({
            detail: {
                ...detail,
                draft: {
                    ...detail.draft,
                    [section]: {
                        ...detail.draft[section],
                        [field]: normalizedValue,
                    },
                },
            },
        });
    },
});
